import { Alert } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useState } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


export function Alertmsg(props) {

  // const [showAlert, setShowAlert] = useState(true);

  // const closeAlert = () => {
  //   setShowAlert(false);
  // };

  return (
    <Alert variant="info" dismissible className="solid">
    <strong>Download Employee RTW PDF</strong>
    <p className="fs-12 mb-1">
      To download the employee’s Right to Work (RTW) PDF, follow these steps:
    </p>
    <ul className="fs-12 ps-3">
      <li className="mb-2">Open the RTW service via <Link to="https://www.gov.uk/view-right-to-work" target="_blank">this link</Link>.</li>
      <li className="mb-2">Click the <strong>Start now</strong> button.</li>
      <li className="mb-2">Enter the <strong>share code</strong> provided and click <strong>Continue</strong>.</li>
      <li className="mb-2">Enter the employee’s <strong>date of birth</strong> and click <strong>Continue</strong>.</li>
      <li className="mb-2">Enter your <strong>company name</strong> and click <strong>Continue</strong>.</li>
      <li className="mb-2">Download the RTW PDF file.</li>
    </ul>
    <button className="btn-close" onClick={props.closeAlert}>
      <span>
        <i className="fa-solid fa-xmark"></i>
      </span>
    </button>
  </Alert>
  
  );
}

export const validateEmail = (email) => {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return pattern.test(email)
}

const CustomTooltip = ({ id, message, children }) => {
  return (
    <OverlayTrigger key={`tooltip-${id}`} placement="top" overlay={<Tooltip id={`tooltip-${id}`}>{message}</Tooltip>}>
      {children}
    </OverlayTrigger>
  );
};
export default CustomTooltip;


